import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoEyeOutline, IoEyeOffOutline, IoClose } from "react-icons/io5";
import { getUsers, loginUser, updateUser, getCustomUser } from "../api";
import { getStableDeviceId } from "../utils/deviceId";
import "../styles/sifaris.css";

const WA = {
dark: "#075E54",
main: "#128C7E",
accent: "#25D366",
bg: "#f0efeeff",
white: "#FFFFFF",
text: "#111827",
border: "#C8D5CF",
placeholder: "#7BA89C",
};

const AppModal = ({
open,
title = "Diqqət",
message = "",
type = "info",
buttonText = "Bağla",
onClose,
actions,
}) => {
if (!open) return null;

return (  
    <div className="sq-modal-overlay">  
        <div className="sq-alert-modal">  
            <button className="sq-close-btn" onClick={onClose} type="button">  
                <IoClose size={22} />  
            </button>  

            <h3 className={`sq-alert-title sq-alert-${type}`}>{title}</h3>  
            <p className="sq-alert-message">{message}</p>  

            {actions?.length ? (  
                <div className="sq-alert-actions">  
                    {actions.map((action, index) => (  
                        <button  
                            key={index}  
                            type="button"  
                            className={`sq-alert-button ${action.variant === "secondary" ? "sq-alert-button-secondary" : ""}`}  
                            onClick={action.onClick}  
                        >  
                            {action.label}  
                        </button>  
                    ))}  
                </div>  
            ) : (  
                <button className="sq-alert-button" onClick={onClose} type="button">  
                    {buttonText}  
                </button>  
            )}  
        </div>  
    </div>  
);

};

const LoginScreen = () => {
const navigate = useNavigate();

const [phoneNumber, setPhoneNumber] = useState("");  
const [password, setPassword] = useState("");  
const [isUserTypeModalVisible, setIsUserTypeModalVisible] = useState(false);  
const [courierTypeModalVisible, setCourierTypeModalVisible] = useState(false);  
const [loading, setLoading] = useState(false);  
const [showPassword, setShowPassword] = useState(false);  

const [modalOpen, setModalOpen] = useState(false);  
const [modalConfig, setModalConfig] = useState({  
    title: "",  
    message: "",  
    type: "info",  
    buttonText: "Bağla",  
    actions: null,  
});  

const showModal = ({  
    title = "Diqqət",  
    message = "",  
    type = "info",  
    buttonText = "Bağla",  
    actions = null,  
}) => {  
    setModalConfig({ title, message, type, buttonText, actions });  
    setModalOpen(true);  
};  

const closeModal = () => {  
    setModalOpen(false);  
};  

const handlePhoneChange = (value) => {  
    const cleaned = value.replace(/[^0-9]/g, "");  
    setPhoneNumber(cleaned);  
};  

const updateUserWebSession = async () => {  
    try {  
        const userId = localStorage.getItem("id");  
        if (!userId) return;  

        const userDataResponse = await getCustomUser(userId);  
        const userData = userDataResponse?.data;  

        if (!userData) {  
            showModal({  
                title: "Xəta",  
                message: "İstifadəçi məlumatları alınmadı.",  
                type: "error",  
            });  
            return;  
        }  

        let storedUserType = localStorage.getItem("userType");  
        let storedCourierType = localStorage.getItem("courierType");  
        let storedDeviceId = localStorage.getItem("deviceUUID");  

        if (!storedDeviceId) {  
            storedDeviceId = await getStableDeviceId();  
            localStorage.setItem("deviceUUID", storedDeviceId);  
        }  

        if (storedUserType === "courier") {  
            storedUserType =  
                storedCourierType === "moto"  
                    ? "moto_courier"  
                    : storedCourierType === "car"  
                        ? "car_courier"  
                        : "courier";  
        }  

        let updatedPhoneId = userData.phoneId || storedDeviceId;  

        if (userData.phoneId && userData.phoneId !== storedDeviceId) {  
            updatedPhoneId = storedDeviceId;  

            showModal({  
                title: "Yeni Cihazda Giriş!",  
                message:  
                    "Sizin hesaba öncədən digər cihazda giriş edildiyi üçün, əvvəlki cihazdan çıxış edildi!",  
                type: "info",  
            });  
        }  

        const updatedData = {  
            ...userData,  
            userType: storedUserType,  
            phoneId: updatedPhoneId,  
        };  

        await updateUser(userId, updatedData);  
        await syncOneSignalLogin(userId);  

        localStorage.setItem("sifarisLoggedIn", "true");  

        const permissionCompleted =  
            localStorage.getItem("sifarisPermissionCompleted") === "true";  

        showModal({  
            title: "Uğurlu",  
            message:  
                storedUserType === "customer"  
                    ? "Müştəri olaraq giriş edildi."  
                    : storedUserType === "moto_courier"  
                        ? "Moto Kuryer olaraq giriş edildi."  
                        : storedUserType === "car_courier"  
                            ? "Maşın Kuryer olaraq giriş edildi."  
                            : "Kuryer olaraq giriş edildi.",  
            type: "success",  
            actions: [  
                {  
                    label: "Davam et",  
                    onClick: () => {  
                        closeModal();  
                        navigate( permissionCompleted  
                                 ? "/sifaris/order-group"  
                                : "/sifaris/permission"  
                        );  
                    },  
                },  
            ],  
        });  
    } catch (error) {  
        console.error("İstifadəçi güncəllənərkən xəta:", error);  
        showModal({  
            title: "Xəta",  
            message: "İstifadəçi məlumatları yenilənmədi.",  
            type: "error",  
        });  
    } finally {  
        setLoading(false);  
    }  
};  

const handleUserTypeSelection = async (type) => {  
    localStorage.setItem("userType", type);  
    setIsUserTypeModalVisible(false);  

    if (type === "courier") {  
        setTimeout(() => {  
            setCourierTypeModalVisible(true);  
        }, 300);  
    } else {  
        await updateUserWebSession();  
    }  
};  

const handleCourierTypeSelection = async (type) => {  
    localStorage.setItem("courierType", type);  
    setCourierTypeModalVisible(false);  
    await updateUserWebSession();  
};  

const handleRegisterNavigation = () => {  
    navigate("/sifaris/register");  
};  

const handleLogin = async () => {  
    if (!phoneNumber || !password) {  
        showModal({  
            title: "Diqqət",  
            message: "Zəhmət olmasa bütün sahələri doldurun.",  
            type: "warning",  
        });  
        return;  
    }  

    setLoading(true);  

    try {  
        const stableDeviceId = await getStableDeviceId();  
        localStorage.setItem("deviceUUID", stableDeviceId);  

        const customersResponse = await getUsers();  
        const customers = customersResponse?.data || [];  
        const matchingUser = customers.find((user) => user.phoneNumber === phoneNumber);  

        const deviceBlocked = customers.some(  
            (u) => u?.phoneId === stableDeviceId && u?.isDisable === true  
        );  

        if (deviceBlocked) {  
            showModal({  
                title: "Diqqət!",  
                message: "Hesabınız bloklanıb.",  
                type: "error",  
            });  
            setLoading(false);  
            return;  
        }  

        if (!matchingUser) {  
            showModal({  
                title: "Diqqət",  
                message: "Bu telefon nömrəsi ilə qeydiyyatlı istifadəçi tapılmadı.",  
                type: "warning",  
            });  
            setLoading(false);  
            return;  
        }  

        if (matchingUser.isDisable) {  
            showModal({  
                title: "Diqqət!",  
                message: "Hesabınız Admin tərəfindən bloklanmış və ya deaktiv edilmişdir!",  
                type: "error",  
            });  
            setLoading(false);  
            return;  
        }  

        if (matchingUser.password !== password) {  
            showModal({  
                title: "Diqqət",  
                message: "Şifrə yanlışdır. Zəhmət olmasa düzgün şifrə daxil edin.",  
                type: "error",  
            });  
            setLoading(false);  
            return;  
        }  

        const loginRequest = { phoneNumber, password };  
        const loginResponse = await loginUser(loginRequest);  

        if (!loginResponse || !loginResponse.data) {  
            showModal({  
                title: "Giriş məlumatları",  
                message: "Giriş məlumatları yanlışdır.",  
                type: "error",  
            });  
            setLoading(false);  
            return;  
        }  

        const user = loginResponse.data;  
        let storedUserType = localStorage.getItem("userType");  

        localStorage.setItem("password", password);  
        localStorage.setItem("id", user.id?.toString());  
        localStorage.setItem("sifarisLoggedIn", "true");  
        localStorage.removeItem("sifarisPermissionCompleted");  

        if (!storedUserType) {  
            setIsUserTypeModalVisible(true);  
            setLoading(false);  
            return;  
        }  

        await handleUserTypeSelection(storedUserType);  
    } catch (error) {  
        console.error("Giriş zamanı xəta baş verdi:", error);  
        showModal({  
            title: "Xəta",  
            message: "Giriş zamanı xəta baş verdi. Daha sonra sınayın.",  
            type: "error",  
        });  
        setLoading(false);  
    }  
};  

const syncOneSignalLogin = async (appUserId) => {  
try {  
    if (!appUserId || !window.OneSignalDeferred) return;  

    window.OneSignalDeferred.push(async function (OneSignal) {  
        await OneSignal.login(String(appUserId));  

        const subscriptionId = OneSignal.User?.PushSubscription?.id;  

        if (subscriptionId) {  
            await updateUser(appUserId, {  
                oneSignal: subscriptionId,  
                platform: "web",  
            });  
        }  
    });  
} catch (error) {  
    console.error("OneSignal login sync xətası:", error);  
}

};

return (  
    <>  
        <div  
            className="sq-page"  
            style={{  
                backgroundColor: WA.bg,  
                minHeight: "100vh",  
                display: "flex",  
                alignItems: "center",  
                justifyContent: "center",  
                padding: "20px",  
            }}  
        >  
            <div className="sq-card">  
                <h1 className="sq-title">Sifariş Qrupu</h1>  

                <input  
                    className="sq-input"  
                    placeholder="Telefon Nömrənizi Daxil Edin"  
                    value={phoneNumber}  
                    onChange={(e) => handlePhoneChange(e.target.value)}  
                    maxLength={10}  
                    inputMode="numeric"  
                />  

                <div className="sq-password-wrap">  
                    <input  
                        className="sq-input sq-password-input"  
                        placeholder="Şifrə Daxil Edin"  
                        type={showPassword ? "text" : "password"}  
                        value={password}  
                        onChange={(e) => setPassword(e.target.value)}  
                    />  
                    <button  
                        type="button"  
                        onClick={() => setShowPassword((prev) => !prev)}  
                        className="sq-eye-btn"  
                        aria-label={showPassword ? "Şifrəni gizlət" : "Şifrəni göstər"}  
                    >  
                        {showPassword ? (  
                            <IoEyeOffOutline size={22} color="#6B7280" />  
                        ) : (  
                            <IoEyeOutline size={22} color="#6B7280" />  
                        )}  
                    </button>  
                </div>  

                <div className="sq-forgot-row">  
                    <button  
                        type="button"  
                        className="sq-link-btn"  
                        onClick={() =>  
                            navigate("/sifaris/forgot-password", {  
                                state: { initialPhone: phoneNumber },  
                            })  
                        }  
                    >  
                        Şifrəmi unutdum  
                    </button>  
                </div>  

                <button  
                    className="sq-primary-btn"  
                    onClick={handleLogin}  
                    disabled={loading}  
                    type="button"  
                >  
                    {loading ? "Yüklənir..." : "Daxil ol"}  
                </button>  

                <button  
                    type="button"  
                    className="sq-register-link"  
                    onClick={handleRegisterNavigation}  
                >  
                    Qeydiyyat üçün bura tıklayın.  
                </button>  
            </div>  
        </div>  

        {isUserTypeModalVisible && (  
            <div className="sq-modal-overlay">  
                <div className="sq-modal">  
                    <button  
                        className="sq-close-btn"  
                        onClick={() => setIsUserTypeModalVisible(false)}  
                        type="button"  
                    >  
                        <IoClose size={22} />  
                    </button>  

                    <h2 className="sq-modal-title">İstifadəçi növünü seçin</h2>  

                    <button  
                        className="sq-modal-btn"  
                        onClick={() => handleUserTypeSelection("customer")}  
                        type="button"  
                    >  
                        Müştəri  
                    </button>  

                    <button  
                        className="sq-modal-btn"  
                        onClick={() => handleUserTypeSelection("courier")}  
                        type="button"  
                    >  
                        Kuryer  
                    </button>  
                </div>  
            </div>  
        )}  

        {courierTypeModalVisible && (  
            <div className="sq-modal-overlay">  
                <div className="sq-modal">  
                    <button  
                        className="sq-close-btn"  
                        onClick={() => setCourierTypeModalVisible(false)}  
                        type="button"  
                    >  
                        <IoClose size={22} />  
                    </button>  

                    <h2 className="sq-modal-title">Nəqliyyat növünü seçin</h2>  

                    <button  
                        className="sq-modal-btn"  
                        onClick={() => handleCourierTypeSelection("moto")}  
                        type="button"  
                    >  
                        Moto Kuryer  
                    </button>  

                    <button  
                        className="sq-modal-btn"  
                        onClick={() => handleCourierTypeSelection("car")}  
                        type="button"  
                    >  
                        Maşın Kuryer  
                    </button>  
                </div>  
            </div>  
        )}  

        <AppModal  
            open={modalOpen}  
            title={modalConfig.title}  
            message={modalConfig.message}  
            type={modalConfig.type}  
            buttonText={modalConfig.buttonText}  
            actions={modalConfig.actions}  
            onClose={closeModal}  
        />  
    </>  
);

};

export default LoginScreen;
